<template>
	<v-btn
		v-if="isVisible"
		style="position: fixed; bottom: 0.25rem; right: 0.25rem; z-index: 1001"
		color="primary"
		density="comfortable"
		icon
		@click="scrollToTop">
		<v-icon>mdi-arrow-up</v-icon>
	</v-btn>
</template>

<script>
export default {
	data() {
		return {
			isVisible: false,
		};
	},
	methods: {
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		},
		handleScroll() {
			// Show button when user scrolls down 300px
			this.isVisible = window.scrollY > 300;
		},
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style scoped>
.scroll-to-top {
	position: fixed;
	bottom: 20px;
	right: 20px;
	background-color: #007bff;
	color: white;
	border: none;
	border-radius: 50%;
	width: 50px;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: opacity 0.3s, transform 0.3s;
	opacity: 0.8;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.scroll-to-top:hover {
	opacity: 1;
	transform: scale(1.1);
}
</style>
